module.exports = __webpack_public_path__ + "img/img-65.035aaa94.png";